import { useMemo } from 'react';
import { BudgetStatusEnum } from '../../../../enums/budgetStatus';
import { BudgetRecipientEnum } from '../../createAndEdit/types';

interface IUseManagerDetailJourneyParams {
  userProfile?: BudgetRecipientEnum | string;
  budgetRecipient?: BudgetRecipientEnum | string;
  budgetStatus?: BudgetStatusEnum | string;
  isLastVersion?: boolean;
}

export const useManagerDetailJourney = (params: IUseManagerDetailJourneyParams) => {
  const { userProfile, budgetRecipient, budgetStatus, isLastVersion } = params;

  const isManager = userProfile === BudgetRecipientEnum.MANAGER;

  const isApproved = useMemo(() => {
    return budgetStatus === BudgetStatusEnum.APPROVED || budgetStatus === 'Aprovado';
  }, [budgetStatus]);

  const shouldShowActions = useMemo(() => {
    if(!isLastVersion) {
      return false;
    }

    if (!budgetRecipient || !userProfile) {
      return false;
    }
    return budgetRecipient === userProfile && !isApproved;
  }, [budgetRecipient, userProfile, isApproved]);

  const isRejected = useMemo(() => {
    return budgetStatus === BudgetStatusEnum.REJECTED || budgetStatus === 'Rejeitado';
  }, [budgetStatus]);

  const isPending = useMemo(() => {
    return budgetStatus === BudgetStatusEnum.PENDING || budgetStatus === 'Pendente';
  }, [budgetStatus]);

  const shouldShowCloseButton = useMemo(() => {
    return isApproved || isRejected;
  }, [isApproved, shouldShowActions]);

  const shouldShowCloseIcon = useMemo(() => {
    return !isApproved;
  }, [isApproved]);

  const shouldShowCounterProposal = useMemo(() => {
    return shouldShowActions;
  }, [shouldShowActions]);

  return {
    isManager,
    shouldShowActions,
    shouldShowCloseButton,
    shouldShowCloseIcon,
    shouldShowCounterProposal,
    isApproved,
  };
};
